<template>
    <div>
        <!-- 操作区域 -->
        <div style="margin-bottom:10px;">
            <el-button @click="addRec" type="success"><i class="el-icon-circle-plus-outline"></i>&nbsp;新建</el-button>
        </div>

        <!-- 列表区域 -->
        <el-table :data="tableData" @current-change="handleCurrentChange" v-loading.body="tableLoading"
            element-loading-text="信息加载中" stripe border fit highlight-current-row header-cell-class-name="tableHeadStyle"
            :height="mainTableHeight" ref="mainTable" style="width:100%;">
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="课程名称" prop="courseName" align="center"></el-table-column>
            <el-table-column label="所属学制" prop="schoolLenName" align="center"></el-table-column>
            <el-table-column label="所属系部" prop="deptName" align="center"></el-table-column>
            <el-table-column label="所属年级" prop="gradeName" align="center"></el-table-column>
            <el-table-column label="所属专业" prop="majorName" align="center"></el-table-column>
            <el-table-column label="所属班级" prop="className" align="center"></el-table-column>
            <el-table-column label="授课教师" prop="teaName" align="center"></el-table-column>
            <el-table-column label="上课时间" prop="orderTimeName" :formatter="timeFormatter" width="220px" align="center"></el-table-column>
            <el-table-column label="操作" width="180px" align="center">
                <template slot-scope="scope">
                    <el-button type="warning" size="small" @click="modRec(scope.row)">
                        <i class="el-icon-edit"></i>&nbsp;编辑
                    </el-button>
                    <el-button type="danger" size="small" @click="delRec(scope.row)">
                        <i class="el-icon-delete"></i>&nbsp;删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 表单区域 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @closed="closeDialog" width="850px" top="120px" append-to-body>
            <el-form ref="curdForm" :model="curdForm" label-width="120px" label-position="left" :rules="curdRules">
                <el-form-item label="课程名称" prop="courseName">
                    <el-input v-model="curdForm.courseName" placeholder="请填写"></el-input>
                </el-form-item>
                <el-form-item label="上课时间" prop="orderTimeCode">
                    <el-select v-model="curdForm.week" style="width:100px;">
                        <el-option v-for="item in comboOption.week" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                    <el-select v-model="curdForm.time" placeholder="请选择上课时间" style="width:565px;" multiple>
                        <el-option v-for="item in comboOption.time" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属学制" prop="schoolLen">
                    <el-select v-model="schoolLenArray" placeholder="默认全部学制" style="width:100%;" multiple clearable>
                        <el-option v-for="(item, index) in comboOption.schoolLen" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属院系" prop="deptCode">
                    <el-select v-model="deptCodeArray" placeholder="默认全部院系" style="width:100%;" @change="handleDeptChange" multiple clearable>
                        <el-option v-for="(item, index) in comboOption.dept" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属年级" prop="gradeCode">
                    <el-select v-model="gradeCodeArray" placeholder="默认全部年级" style="width:100%;" @change="handleGradeChange" multiple clearable>
                        <el-option v-for="(item, index) in comboOption.grade" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属专业" prop="majorCode">
                    <el-select v-model="majorCodeArray" placeholder="默认全部专业" style="width:100%;" @change="handleMajorChange" multiple filterable clearable>
                        <el-option v-for="(item, index) in comboOption.major" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属班级" prop="classCode">
                    <el-select v-model="classCodeArray" placeholder="默认全部班级" style="width:100%;" multiple filterable clearable>
                        <el-option v-for="(item, index) in comboOption.class" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="授课教师" prop="teaCode">
                    <el-select v-model="teaCodeArray" placeholder="可选择授课教师（班会课不选择默认为班主任）" style="width:100%;" multiple filterable clearable>
                        <el-option v-for="(item, index) in comboOption.tea" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="margin-top: 10px">
                <el-button type="primary" @click="saveRec">保存</el-button>
                <el-button @click="dialogVisible = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        data() {
            return {
                queryForm: {
                    semesterCode: null,
                },
                comboOption: {
                    week: null,
                    time: null,
                    schoolLen: null,
                    dept: null,
                    grade: null,
                    major: null,
                    class: null,
                    tea: null,
                },
                tableData: [],
                tableLoading: true,
                mainTableHeight: 500,
                dialogVisible: false,
                dialogTitle: null,
                curdForm: {
                    id: null,
                    semesterCode: null,
                    courseName: null,
                    week: null,
                    time: [],
                    orderTimeCode: null,
                    orderTimeName: null,
                    schoolLen: null,
                    deptCode: null,
                    gradeCode: null,
                    majorCode: null,
                    classCode: null,
                    teaCode: null,
                    teaName: null,
                    siteCode: '',
                    siteName: '',
                    weekNum: '',
                },
                schoolLenArray: [],
                deptCodeArray: [],
                gradeCodeArray: [],
                majorCodeArray: [],
                classCodeArray: [],
                teaCodeArray: [],
                curdRules: {
                    courseName: [{
                        required: true,
                        message: "请填写课程名称",
                    }]
                },
            }
        },
        mounted() {
            this.queryList();
            this.initCombo();

            // this.$nextTick().then(() => {
            //     //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
            //     //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
            //     this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
            //     // 监听窗口大小变化
            //     let self = this;
            //     window.onresize = function() {
            //         self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
            //     };
            // });
        },
        methods: {
            initCombo() {
                this.$api.timetableManage.customCourse.initCombo({
                    data: this.queryForm
                }).then((res) => {
                    this.comboOption.week = res.data.data.weekComboData;
                    this.curdForm.week = this.comboOption.week[0].comboValue;
                    this.comboOption.time = res.data.data.timeQuantumComboData;
                    this.curdForm.time.push(this.comboOption.time[0].comboValue);
                    this.comboOption.schoolLen = res.data.data.schoolLenComboData;
                    this.comboOption.tea = res.data.data.teaComboData;
                    this.loadDeptCombo();
                    this.loadGradeCombo();
                }).catch((err) => {
                    console.log(err);
                });
            },
            loadDeptCombo(){
                this.$api.timetableManage.arrange.loadDeptCombo4Del({
                    data: {
                        semesterCode: this.queryForm.semesterCode
                    }
                }).then((res) => {
                    this.comboOption.dept = res.data.data.deptComboData;
                    this.loadMajorCombo();
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            handleDeptChange(value){
                this.loadMajorCombo();
            },
            loadGradeCombo(){
                this.$api.timetableManage.arrange.loadGradeCombo4Del({
                    data: {
                        semesterCode: this.queryForm.semesterCode,
                    }
                }).then((res) => {
                    this.comboOption.grade = res.data.data.gradeComboData;
                    this.loadClassCombo();
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            handleGradeChange(value){
                this.loadClassCombo();
            },
            loadMajorCombo(){
                this.$api.timetableManage.arrange.loadMajorCombo4Del({
                    data: {
                        semesterCode: this.queryForm.semesterCode,
                        deptCode: this.deptCodeArray.length===0 ? '' : this.deptCodeArray.toString(),
                    }
                }).then((res) => {
                    this.comboOption.major = res.data.data.majorComboData;
                    this.loadClassCombo();
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            handleMajorChange(value){
                this.loadClassCombo();
            },
            loadClassCombo(){
                this.$api.timetableManage.arrange.loadClassCombo4Del({
                    data: {
                        semesterCode: this.queryForm.semesterCode,
                        deptCode: this.deptCodeArray.length===0 ? '' : this.deptCodeArray.toString(),
                        gradeCode: this.gradeCodeArray.length===0 ? '' : this.gradeCodeArray.toString(),
                        majorCode: this.majorCodeArray.length===0 ? '' : this.majorCodeArray.toString(),
                    }
                }).then((res) => {
                    this.comboOption.class = res.data.data.classComboData;
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            queryList() {
                this.tableLoading = true;
                this.$api.timetableManage.customCourse.list({
                    data: this.queryForm,
                }).then((res) => {
                    this.tableData = res.data.data.list;
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.tableLoading = false;
                });
            },
            handleCurrentChange(val, old) {
            },
            timeFormatter(row){
                return row.orderTimeName.replace(/\,/g, '\n');
            },
            addRec(){
                this.dialogTitle = "新建";
                this.dialogVisible = true;
            },
            modRec(rowData){
                this.dialogTitle = "编辑";
                this.dialogVisible = true;

                this.$nextTick().then(() => {
                    this.curdForm.id = rowData.id;
                    this.curdForm.courseName = rowData.courseName;
                    let orderTimeArray = rowData.orderTimeCode.split(',');
                    this.curdForm.week = orderTimeArray[0].substring(0, 2);
                    this.curdForm.time = [];
                    for(let i=0; i<orderTimeArray.length; i++){
                        this.curdForm.time.push(orderTimeArray[i].substring(2));
                    }
                    this.schoolLenArray = rowData.schoolLen==='' ? [] : rowData.schoolLen.split(',');
                    this.deptCodeArray = rowData.deptCode==='' ? [] : rowData.deptCode.split(',');
                    this.majorCodeArray = rowData.majorCode==='' ? [] : rowData.majorCode.split(',');
                    this.gradeCodeArray = rowData.gradeCode==='' ? [] : rowData.gradeCode.split(',');
                    this.classCodeArray = rowData.classCode==='' ? [] : rowData.classCode.split(',');
                    this.teaCodeArray = rowData.teaCode==='' ? [] : rowData.teaCode.split(',');
                });
            },
            saveRec() {
                this.$refs['curdForm'].validate((valid) => {
                    if (valid) {
                        if(this.curdForm.time.length === 0){
                            this.$alert('请选择上课时间', '提示', {
                                confirmButtonText: '确定'
                            });
                            return;
                        }

                        this.handleCurdData();
                        
                        this.$api.timetableManage.customCourse.save({
                            data: this.curdForm,
                        }).then((res) => {
                            let state = res.data.data.state;
                            switch (state) {
                                case 'success':
                                    this.dialogVisible = false;
                                    showNotify('成功', '保存成功', 'success', 1500);
                                    this.queryList();
                                    break;
                                default:
                                    showNotify('错误', '保存失败', 'error', 3000);
                                    break;
                            }
                        }).catch((err) => {
                            console.log(err);
                        });
                    } else {
                        return false;
                    }
                });
            },
            handleCurdData(){
                this.curdForm.semesterCode = this.queryForm.semesterCode;
                this.curdForm.orderTimeCode = '';
                this.curdForm.orderTimeName = '';

                //节次排序
                this.curdForm.time.sort();

                const weekCode = this.curdForm.week;
                let weekName = '';
                for(let i=0; i<this.comboOption.week.length; i++){
                    if(weekCode === this.comboOption.week[i].comboValue){
                        weekName = this.comboOption.week[i].comboName;
                        break;
                    }
                }

                for(let i=0; i<this.curdForm.time.length; i++){
                    this.curdForm.orderTimeCode += weekCode + this.curdForm.time[i] + ',';

                    let timeName = '';
                    for(let j=0; j<this.comboOption.time.length; j++){
                        if(this.curdForm.time[i] === this.comboOption.time[j].comboValue){
                            timeName = this.comboOption.time[j].comboName;
                            break;
                        }
                    }
                    this.curdForm.orderTimeName += weekName + timeName + ',';
                }

                this.curdForm.orderTimeCode = this.curdForm.orderTimeCode.substring(0, this.curdForm.orderTimeCode.length-1);
                this.curdForm.orderTimeName = this.curdForm.orderTimeName.substring(0, this.curdForm.orderTimeName.length-1);
                this.curdForm.schoolLen = this.schoolLenArray.toString();
                this.curdForm.deptCode = this.deptCodeArray.toString();
                this.curdForm.majorCode = this.majorCodeArray.toString();
                this.curdForm.gradeCode = this.gradeCodeArray.toString();
                this.curdForm.classCode = this.classCodeArray.toString();
                this.curdForm.teaCode = this.teaCodeArray.toString();
                let tempTeaName = '';
                for(let i=0; i<this.teaCodeArray.length; i++){
                    for(let j=0; j<this.comboOption.tea.length; j++){
                        if(this.teaCodeArray[i] === this.comboOption.tea[j].comboValue){
                            if(tempTeaName.length > 0) {
                                tempTeaName += ',';
                            }
                            tempTeaName += this.comboOption.tea[j].comboName.replace('（'+this.comboOption.tea[j].comboValue+'）', '');
                        }
                    }
                }
                this.curdForm.teaName = tempTeaName;
            },
            delRec(rowData){
                confirmMsg('是否确定要删除当前选择的自定义课程').then(() => {
                    this.$api.timetableManage.customCourse.del({
                        data: {
                            id: rowData.id
                        },
                    }).then((res) => {
                        let state = res.data.data.state;
                        switch (state) {
                            case 'success':
                                this.dialogVisible = false;
                                showNotify('成功', '删除成功', 'success', 1500);
                                this.queryList();
                                break;
                            default:
                                showNotify('错误', '删除失败', 'error', 3000);
                                break;
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
            //关闭对话框
            closeDialog() {
                if(this.$refs['curdForm'] !== undefined){
                    this.$refs['curdForm'].clearValidate();
                    this.$refs['curdForm'].resetFields();
                }

                this.curdForm.id = null;
                this.curdForm.week = this.comboOption.week[0].comboValue;
                this.curdForm.time.length = 0;
                this.curdForm.time.push(this.comboOption.time[0].comboValue);
                this.schoolLenArray = [];
                this.deptCodeArray = [];
                this.gradeCodeArray = [];
                this.majorCodeArray = [];
                this.classCodeArray = [];
                this.teaCodeArray = [];
            },
        },
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// customCourse.vue?0bcb124e